const ACTION_STATE_CLASSES = Object.freeze({
  disabled: 'ui-action--disabled',
  loading: 'ui-action--loading',
  selected: 'ui-action--selected',
});

export function setActionState(element, state, enabled = true) {
  const stateClass = ACTION_STATE_CLASSES[state];
  if (!stateClass || !(element instanceof HTMLElement)) return;
  element.classList.toggle(stateClass, enabled);
  if (state === 'disabled' && 'disabled' in element) element.disabled = enabled;
  if (state === 'loading') {
    element.setAttribute('aria-busy', String(enabled));
    if ('disabled' in element) element.disabled = enabled;
  }
  if (state === 'selected') element.setAttribute('aria-pressed', String(enabled));
}
